/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import { ICnpjValidator, ICpfValidator } from 'Models/cadastros/IValidator'
import ApiService from 'Services/ApiService'

const validadores = {
  cnpj: async (cnpj: string) => {
    const result: AxiosResponse<ICnpjValidator> =
      await ApiService().get<ICnpjValidator>(
        `${hosts.WS_CADASTRO}/cnpj/${cnpj}`,
      )

    return result
  },
  cpf: async (cpf: string, from: string) => {
    const result: AxiosResponse<ICpfValidator> =
      await ApiService().get<ICpfValidator>(
        `${hosts.WS_CADASTRO}/cpf/${cpf}?cpfFrom=${from}`,
      )

    return result
  },
}

export default validadores
